<section class="editDocument__container">
  <header>
    <app-offcanvas-header paddingClass="paddingClass"
      header="{{ documentType ? 'Edit Category Type' : 'Add Category Type' }}"
      (closeClicked)="onCloseIconClick(false)"></app-offcanvas-header>
  </header>
  <form class="mt-3" [formGroup]="documentTypeFormGroup">
    <div class="offcanvas__content">
      <div class="offcanvas__orgDetails">
        <div class="offCanvas__orgName-inputField">
          <app-input-filed label="Name" placeholder="Enter name" [control]="$any(documentTypeFormGroup).controls['name']"
            [starIcon]="'*'" [value]="documentType?.name"></app-input-filed>
          <small class="text-danger"
            *ngIf="documentTypeFormGroup.get('name')?.errors?.['required'] && documentTypeFormGroup.get('name')?.touched">
            Name is required.
          </small>
          <small class="text-danger"
            *ngIf="(documentTypeFormGroup.get('name')?.dirty || documentTypeFormGroup.get('name')?.touched) && documentTypeFormGroup.get('name')?.errors?.['pattern']">
            Please use only letters and numbers
          </small>
          <small *ngIf="errorMessage" class="text-danger">{{ errorMessage }}
          </small>
        </div>
      </div>
      <div *ngIf="!documentType" appAccessControl allowedModules="documentVault.ocrCategory">
        <div class="documentType__dropdown col-md-6">
          <div class="documentType__dropdownLabel">
            OCR Category
          </div>
          <select class="docType__dropdownOptions cursor-pointer" (change)="onSelectOcrCategory($event)">
            <option value="Select Document Category" disabled selected [ngValue]="''">Select Document Category</option>
            <option class="cursor-pointer" *ngFor="let item of ocrCategoryList" [ngValue]="item">
              {{ item?.name }}
            </option>
          </select>
        </div>
      </div>
      
      <div class="card mt-2" *ngIf="selectedOcrCategory && !documentType" appAccessControl allowedModules="documentVault.ocrCategory">
        <div class="card-header ocrImageTitle">
          <div >
            Selected OCR Category
          </div>
          <div (click)="openMaxView(previewOcrDoc)">
            <fa-icon class="cursor" [icon]="faExpand" data-bs-toggle="tooltip" ></fa-icon>
          </div>
        </div>
        <div class=" ocrImageDiv ">
          <div class="imgDiv">
            <img alt="sample document" [src]="selectedOcrCategory?.originalDocument" />
          </div>
          <div class="imgDiv">
            <img alt="sample document" [src]="selectedOcrCategory?.parsedDocument" />
          </div>
        </div>
      </div>
    </div>
          
    <div class="offcanvas__content" *ngIf="tabvalue == 'recordtype'">
      <div class="offcanvas__orgDetails">
        <div class="offCanvas__orgName-inputField">
          <app-input-filed label="Record Type" placeholder="Enter recordtype" class="mt-3"
            [control]="$any(documentTypeFormGroup).controls['recordtype']" [starIcon]="'*'"
            [value]="documentType?.name"></app-input-filed>
          <small class="text-danger"
            *ngIf="documentTypeFormGroup.get('recordtype')?.invalid && documentTypeFormGroup.get('recordtype')?.touched">
            Record Type is required.
          </small>
          <small *ngIf="errorMessage" class="text-danger">{{ errorMessage }}>
          </small>
        </div>
      </div>
    </div>
         
    <div class="offcanvas__content" *ngIf="tabvalue == 'contracttype'">
      <div class="offcanvas__orgDetails">
        <div class="offCanvas__orgName-inputField">
          <app-input-filed label="Contract Type" placeholder="Enter contracttype"
            [control]="$any(documentTypeFormGroup).controls['contracttype']" [starIcon]="'*'"
            [value]="documentType?.name"></app-input-filed>
          <small class="text-danger"
            *ngIf="documentTypeFormGroup.get('contracttype')?.invalid && documentTypeFormGroup.get('contracttype')?.touched">
            Contract Type is required.
          </small>
          <small *ngIf="errorMessage" class="text-danger">{{ errorMessage }}>
          </small>
        </div>
      </div>
    </div>

 <div class="offcanvas__content" *ngIf="tabvalue === 'contracttype' || tabvalue === 'recordtype'">
  <div class="offcanvas__orgDetails">
    <div class="offCanvas__orgName-inputField">
      <app-input-filed *ngIf="tabvalue === 'contracttype' || tabvalue === 'recordtype'" label="Description"
        placeholder="Enter description" [control]="$any(documentTypeFormGroup).controls['description']" 
        [value]="documentType?.name">
      </app-input-filed>
    </div>
  </div>
</div>


<div class="form-group" *ngIf="!showDropDown">
  <span class="filterOffcanvas__inputlabel">Select MetaData</span>
  <div class="form-control form-select filterOffcanvas__inputlabel">
    <div (mouseleave)="showDropDown = false">
      <button class="drop-toggle btn flat" (click)="showDropdown()">
        <span class="spancolor" *ngIf="checkedMultiList.length<=0">
          Select MetaData</span>
        <span class="spancolor" *ngIf="checkedMultiList.length>0">{{checkedMultiList.join(', ')}}</span>
      </button>
      <div class="drop-show" *ngIf="showDropDown && listData.length>0">
        <div class="usersFilter__branchesField">
          <div class="usersFilter__branchWrappar">
            <img class="usersFilter__searchIcon" src="../../../../assets/Images/user-management/searchIcon.svg"
              alt="search" />
            <input (input)="handleFilter($event)" class="usersFilter__input" placeholder="Search" />
          </div>
        </div>
        <label for="checkBoxName" *ngFor="let item of listData">
          <app-checkbox id="checkBoxName" checkboxStatus="{{item.checked}}"
            (checked)="getMultiSelectedValue($event.event.target.checked, item)"></app-checkbox>
          <span>{{item.label}}</span>
        </label>
      </div>
    </div>
  </div>
</div>

  </form>
  <div class="editDocument__footer">
    <div class="offCanvas__footer">
      <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
        (clickEvent)="onCloseIconClick(false)"></app-common-button>
      <app-common-button *ngIf="(documentType ? hasEditAccess : true) && commonService.orgLock()"
      buttonClass="smallFilledButton" buttonLabel="Save" (clickEvent)="onSubmit()"
        [loadingIcon]="verifyLoader" [disabled]="documentTypeFormGroup.invalid"></app-common-button>
    </div>
  </div>
</section>

<div>
  <ng-template #previewOcrDoc let-modal style="z-index: 999">
    <div class="modal-header zindex-modal">
      <h4 class="modal-title" id="modal-basic-title">
        Preview OCR Document
      </h4>
      <div class="cursor" (click)="modal.close(false)" class="close"><img
          src="../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon"></div>
    </div>
    <div class="modal-body">
      <div class=" ocrImagemaxDiv ">
        <div class="maxImage">
          <img alt="sample document" [src]="selectedOcrCategory?.originalDocument" />
        </div>
        <fa-icon  [icon]="faArrowRight"  data-bs-toggle="tooltip" ></fa-icon>
        <div class="maxImage">
          <img alt="sample document" [src]="selectedOcrCategory?.parsedDocument" />
        </div>
      </div>
    </div>
  </ng-template>
</div>